import { LoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/LoginError";
import { LoggedOutContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { trackSigninTooManyAttemptsContactUsClick } from "@faire/web-api--source/events/signin/click/tooManyAttemptsContactUs";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Row, Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { FC, type JSX } from "react";

interface IProps {
  error?: LoginError;
  onResend: () => Promise<void>;
  showResend: boolean;
  mfaMethod?: keyof typeof MfaMethod;
}

export const ResendCode: FC<IProps> = ({
  error,
  onResend,
  showResend,
  mfaMethod,
}) => {
  const { strictLocalize } = useStrictLocalization();
  //For usage on enterMFA view, since it already has a custom error message, we wont pass the error to this component
  if (error) {
    return (
      <Typography>
        <StrictLocalMsg
          id="xgik6d"
          defaultMessage="Sorry! We encountered an unexpected error, please <LoggedOutContactFormLinkFormatting>Contact Us</LoggedOutContactFormLinkFormatting>"
          description={{
            text: "This is displayed if there are error sending the recovery code to the user",
            img: "https://cdn.faire.com/fastly/1646246e95e555c20bd5350ce71cbda26bc9997cadc706a2894f15e51bd62f5d.png",
          }}
          values={{
            LoggedOutContactFormLinkFormatting,
          }}
        />
      </Typography>
    );
  }

  const resendCTAText =
    mfaMethod === MfaMethod.SMS
      ? strictLocalize({
          id: "G5ujgH",
          defaultMessage: "Resend code",
          description: {
            text: "Resend MFA code",
            img: "https://cdn.faire.com/fastly/6bdaf15ce8bfff39f756a9cab119c7fe403cd3c3f2203b01353d24df664dd7dd.png",
          },
        })
      : strictLocalize({
          id: "vHIkKA",
          defaultMessage: "Resend email",
          description: {
            text: "Resend MFA code by email",
            img: "https://cdn.faire.com/fastly/09045ea736d0613118b3ae8638b5f3340aef05a47665ed55eb09c20f2fa45282.png",
          },
        });
  return (
    <Row>
      <Column align="center">
        <Typography>
          {showResend ? (
            <Button variant="tertiary" onClick={onResend}>
              {resendCTAText}
            </Button>
          ) : (
            <StrictLocalMsg
              id="lbvnwk"
              defaultMessage="Code resent. Still didn't receive it? <LoggedOutContactFormLinkWithPETEFormatting>Contact Us</LoggedOutContactFormLinkWithPETEFormatting>"
              description={{
                text: "This is displayed after we send a recovery code to users",
                img: "https://cdn.faire.com/fastly/ed31848f81c881c360af7cfd5634db226c16fe413b29ea4f3d4ab5c075473d4d.png",
              }}
              values={{
                LoggedOutContactFormLinkWithPETEFormatting: (
                  chunk: JSX.Element
                ) =>
                  LoggedOutContactFormLinkFormatting(chunk, () =>
                    trackSigninTooManyAttemptsContactUsClick()
                  ),
              }}
            />
          )}
        </Typography>
      </Column>
    </Row>
  );
};
